import context from './context';
import newContext from './newContext';

const viewsModule = {
  namespaced: true,
  modules: {
    context,
    newContext
  },
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {}
};

export default viewsModule;
